// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a8b72a4084711c73f666","655":"2f490f0d20a22bfd8d97"}[chunkId] + ".js";
};